export default "__VITE_ASSET__Dn$FOPRl__"